import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import StripeAccount from './StripeAccount'

interface StripeAccountModalProps extends BaseModalProps {}

export const StripeAccountModal: React.FunctionComponent<StripeAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <StripeAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
